import { render, staticRenderFns } from "./EformElementEditSignature.vue?vue&type=template&id=13f1d45e&scoped=true&"
import script from "./EformElementEditSignature.vue?vue&type=script&lang=js&"
export * from "./EformElementEditSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f1d45e",
  null
  
)

export default component.exports